export default __webpack_public_path__ + "static/media/12-20.4f7ea7ca.jpeg";